import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

import { CacheKeys } from '@/lib/cache'
import { toCamelCase } from '@/lib/typeHelper'
import type { RequoteChange } from '@/models/user'

export enum RequoteRequestStatus {
  WAITING = 'WAITING',
  REQUOTED = 'REQUOTED',
}

/** A customer who asked for a re-quote — one row per application, at its latest request. */
export interface RequoteRequestRow {
  applicationId: string
  orgId: string
  orgName: string
  /** Null when the user who asked has since been deleted. */
  requestedBy: string | null
  dateRequested: string
  requestCount: number
  salesOwner: string | null
  status: RequoteRequestStatus
  /** What changed since the last quote; empty once re-quoted. */
  changes: RequoteChange[]
}

/** `salesOwner` takes what `SalesOwnerFilter` picks: "me", "unassigned" or a staff user's id. */
export function getRequoteRequests(salesOwner = ''): Promise<RequoteRequestRow[]> {
  return axios
    .get('/api/v1/insure/internal/requotes/', { params: salesOwner ? { sales_owner: salesOwner } : {} })
    .then((r) => toCamelCase(r.data) as RequoteRequestRow[])
}

export function useRequoteRequests(salesOwner = '') {
  const { data, isLoading, isError } = useQuery({
    queryKey: [CacheKeys.REQUOTE_REQUESTS, salesOwner],
    queryFn: () => getRequoteRequests(salesOwner),
  })
  return { rows: data ?? [], isLoading, isError }
}
